import { CheckCircle2, Circle, ChevronDown, ChevronRight, AlertTriangle } from "lucide-react";
import { useState } from "react";

const COLS = "grid grid-cols-[minmax(0,2.2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,2fr)]";

const Productos = ({ prods }) => (
  <div className="mt-1 text-[12px] sm:text-sm">
    <div className={`${COLS} gap-x-1 bg-black text-white font-bold rounded-sm px-1.5`}>
      <span>Cant. · Producto</span><span>Tamaño</span><span>Estilo</span><span>Color</span><span>Comentario</span>
    </div>
    {prods.length === 0 && <div className="px-1.5 py-0.5 text-zinc-500 italic">Sin productos asignados (arme el paquete en el Organizador)</div>}
    {prods.map((p, i) => (
      <div key={i} className={`${COLS} gap-x-1 px-1.5 border-b border-zinc-200 last:border-0`}>
        <span className="font-black break-words">{p.cantidad} × {p.producto}</span>
        <span className="break-normal [overflow-wrap:anywhere] sm:break-words text-[11px] sm:text-sm">{p.tamano}</span><span className="break-words">{p.estilo}</span>
        <span className="break-words">{p.color}</span><span className="break-words whitespace-pre-line">{p.comentario}</span>
      </div>
    ))}
  </div>
);

const Paquete = ({ p, numero }) => {
  const ok = p.escaneado;
  return (
    <div className={`rounded-lg border-2 p-2 ${ok ? "border-emerald-500 bg-emerald-50" : "border-red-500 bg-red-50"}`} data-testid={`emp-paq-${numero}-${p.num}`}>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        {ok ? <CheckCircle2 className="w-7 h-7 text-emerald-600 shrink-0" /> : <Circle className="w-7 h-7 text-zinc-400 shrink-0" />}
        <span className="bg-black text-white font-black rounded-md px-3 py-0.5 text-base sm:text-lg">PAQUETE {p.num}</span>
        <span className="bg-[#FFD600] font-black rounded-md px-2 py-0.5 text-sm">de {p.de}</span>
        <span className="font-black text-base sm:text-lg">| {p.productos.reduce((a, x) => a + x.cantidad, 0)} Producto{p.productos.reduce((a, x) => a + x.cantidad, 0) === 1 ? "" : "s"}</span>
        <span className={`ml-auto rounded-full px-3 py-0.5 text-sm font-black text-white ${ok ? "bg-emerald-600" : "bg-red-600"}`} data-testid={`emp-paq-estado-${numero}-${p.num}`}>{ok ? "Escaneado" : "Pendiente"}</span>
      </div>
      <div className="text-[11px] text-zinc-600 font-mono mt-0.5">{p.guia ? `Guía ${p.guia}` : "Sin guía"}{ok && p.by ? ` · ${p.by} · ${p.at}` : ""}</div>
      <Productos prods={p.productos} />
    </div>
  );
};

export const PedidoPaquetes = ({ r }) => {
  const [abierto, setAbierto] = useState(true);
  const completo = r.total_paquetes > 0 && r.escaneados === r.total_paquetes;
  return (
    <div className="rounded-xl border-2 border-[#FFD600] bg-[#FFFBEA] overflow-hidden" data-testid={`emp-pedido-${r.numero}`}>
      <button onClick={() => setAbierto((x) => !x)} className="w-full flex flex-wrap items-center gap-x-2 gap-y-1 bg-[#FFD600] px-3 py-2 text-left" data-testid={`emp-pedido-toggle-${r.numero}`}>
        {abierto ? <ChevronDown className="w-6 h-6" /> : <ChevronRight className="w-6 h-6" />}
        <span className="font-black text-xl sm:text-2xl">{r.numero}</span>
        <span className="font-black text-base sm:text-lg">| {r.total_paquetes} Paquete{r.total_paquetes === 1 ? "" : "s"} | {r.productos} Producto{r.productos === 1 ? "" : "s"}</span>
        <span className="ml-auto inline-flex items-center rounded-full overflow-hidden border-2 border-white font-black text-sm sm:text-base" data-testid={`emp-pedido-avance-${r.numero}`}>
          <span className={`bg-white px-2 ${completo ? "text-emerald-700" : r.escaneados ? "text-black" : "text-red-600"}`}>{r.escaneados}/{r.total_paquetes}</span>
          <span className={`${completo ? "bg-emerald-600" : r.escaneados ? "bg-amber-500" : "bg-red-600"} text-white px-2`}>Escaneados</span>
        </span>
      </button>
      <div className="px-3 pb-1 text-sm">{r.cliente}{r.destino ? ` · ${r.destino}` : ""}{r.empacado_at ? ` · Empacado ${r.empacado_at} · ${r.empacado_por}` : ""}</div>
      {r.aviso && <div className="mx-2 mb-2 flex items-center gap-2 rounded-md bg-red-600 text-white px-3 py-1.5 text-sm font-bold" data-testid={`emp-aviso-${r.numero}`}><AlertTriangle className="w-4 h-4 shrink-0" /> {r.aviso}</div>}
      {abierto && (
        <div className="space-y-2 p-2 pt-0">
          {r.paquetes.map((p) => <Paquete key={p.num} p={p} numero={r.numero} />)}
          {r.sin_paquete.length > 0 && (
            <div className="rounded-lg border-2 border-dashed border-red-500 p-2" data-testid={`emp-sin-paquete-${r.numero}`}>
              <div className="font-black text-red-700">Productos sin paquete</div>
              <Productos prods={r.sin_paquete} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
